module.exports = __webpack_public_path__ + "media/images/client_logos/logo_bouygues_telecom_200-5ae5fef351fc452db3a3d1d21379e89d.png";